/**
 * Helpers for revealing tutorial copy one character at a time.
 *
 * The copy uses `**bold**` markers, so it can't simply be sliced — a slice
 * mid-marker would leave asterisks on screen. Parsing into segments first lets
 * the reveal happen by character index while the formatting stays intact.
 */

/** Splits a page of copy into bold / plain runs. */
export const parseRichText = (page) => {
  const segments = [];
  const pattern = /\*\*(.+?)\*\*/g;
  let cursor = 0;
  let match = pattern.exec(page);

  while (match) {
    if (match.index > cursor) {
      segments.push({ text: page.slice(cursor, match.index), bold: false });
    }
    segments.push({ text: match[1], bold: true });
    cursor = match.index + match[0].length;
    match = pattern.exec(page);
  }

  if (cursor < page.length) {
    segments.push({ text: page.slice(cursor), bold: false });
  }

  return segments;
};

/** A blank line is a deliberate beat, so each block becomes its own page. */
export const splitPages = (description) =>
  (description || '')
    .split(/\n\s*\n/)
    .map((page) => page.trim())
    .filter(Boolean);

export const countCharacters = (segments) =>
  segments.reduce((total, segment) => total + segment.text.length, 0);

/** Returns the segments trimmed to the first `revealed` characters. */
export const revealSegments = (segments, revealed) => {
  const visible = [];
  let remaining = revealed;

  for (const segment of segments) {
    if (remaining <= 0) break;

    if (segment.text.length <= remaining) {
      visible.push(segment);
      remaining -= segment.text.length;
    } else {
      visible.push({ ...segment, text: segment.text.slice(0, remaining) });
      remaining = 0;
    }
  }

  return visible;
};
